import { createFileRoute } from '@tanstack/react-router';

import { AnnualReport } from '@/module/AnnualReport/AnnualReport';

export const Route = createFileRoute('/_auth/report/_report/')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'annualReport.title' },
  },
});

function RouteComponent() {
  return <AnnualReport />;
}
